<script setup>
import { onMounted, ref } from 'vue';
import { useFelixBagAuxStore, useGlobalStateStore } from '../../../store';

import ModalMudanca from './components/ModalMudanca.vue'

const felixBagAuxStore = useFelixBagAuxStore();
const globalStateStore = useGlobalStateStore();

const showModalMudanca = ref(false)
const trilha = ref(window.ovmConfig.env['TRILHA'])

const name = ref('')
const isVisible = ref(true)

onMounted(() => {
  felixBagAuxStore.pauseAfter(77000)
  checkTrilha()
  checkName()
});

function openTrilhaDeCuidados() {
  felixBagAuxStore.showInteractive("trilha-de-cuidado")
}

function openQuadroDeAvisos() {
  felixBagAuxStore.showInteractive("quadro-de-avisos")
}

function interromperClicked() {
  felixBagAuxStore.hideInteractive('menu-principal');
  felixBagAuxStore.showInteractive('interromper')
}

function grandeDiaClicked() {
  felixBagAuxStore.hideInteractive('menu-principal');
  felixBagAuxStore.showInteractive('solicitar-licensa')
}

function checkName() {
  if (window.ovmConfig.env['NOME_SOCIAL']) {
    name.value = window.ovmConfig.env['NOME_SOCIAL'].split(" ")[0]
  } else if (window.ovmConfig.env['NOME_CADASTRADO']) {
    name.value = window.ovmConfig.env['NOME_CADASTRADO'].split(" ")[0]
  } else {
    name.value = window.ovmConfig.env['PRIMEIRO_NOME']
  }
}

function checkTrilha() {
  const trilhas = ['fui_gestante', 'parceira_e_bebe_nasceu', 'processo_adotivo_chegou']
  if (trilhas.includes(globalStateStore.globalState.selectedData.profile.name)) {
    felixBagAuxStore.showInteractive('trilha-de-cuidados-final')
    felixBagAuxStore.hideInteractive('menu-principal')
  } else if (globalStateStore.globalState.selectedData.profile.name === 'acolhimento') {
    felixBagAuxStore.showInteractive('trilha-de-acolhimento')
    felixBagAuxStore.hideInteractive('menu-principal')
  }
}

</script>

<template>
  <div id="menu-principal">
    <v-row align-content="center" justify="space-evenly"
      style="margin-top: 22%;margin-bottom: 10%; padding: 0 7.7% 0 7.5%;" class="top-area">
      <v-avatar style="border: 1px solid #FF9900;" color="white">
        <img v-if="globalStateStore.globalState.selectedData.profile"
          :src="globalStateStore.globalState.selectedData.profile.img" style="width: 100%;" alt="">
      </v-avatar>
      <div style="text-align: start; width: 46%;">
        <p style="color: #464646; font-size: 11px;">Aproveite sua jornada.</p>
        <p style="font-size: 18px; margin-right: 20px;">{{ name }}</p>
      </div>
      <div style="width: 40px; height: 40px;" v-if="['gestante', 'parceria'].includes(trilha)">
        <button
          style="background-color:rgb(102, 0, 153); width: 100%; height: 100%; border-radius: 8px; align-items: center; display: flex; justify-content: center;"
          @click="felixBagAuxStore.showInteractive('upload-exame')">
          <img style="width: 65%;"
            src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/355332a7-a619-4759-8f7c-a739ae92b46c.svg"
            alt="">
        </button>
      </div>
      <div style="width: 40px; height: 40px;">
        <button
          style="background-color:rgb(102, 0, 153); width: 100%; height: 100%; border-radius: 8px; align-items: center; display: flex; justify-content: center;"
          @click="felixBagAuxStore.showInteractive('dicas-de-uso')">
          <img style="width: 65%;"
            src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/d520f86a-9e4e-4455-bc4b-195600a42048.svg"
            alt="">
        </button>
      </div>
    </v-row>

    <div @click="isVisible = false" :class="{ 'hidden': !isVisible }"
      v-if="globalStateStore.exames['EXAME_BETA'].status === 'INVALID' || globalStateStore.exames['EXAME_ULTRASSOM'].status === 'INVALID'"
      class="speech up">Você tem tarefas pendentes aqui!</div>

    <div class="menu-item" @click="openQuadroDeAvisos">
      <v-row>
        <v-col cols="6">
          <img
            src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/f15c3c1c-8ec1-4dcc-9a71-6f80444797dc.svg"
            alt="">
        </v-col>

        <v-col cols="6" class="item-text">
          <p class="item-title">Seu quadro de avisos</p>
        </v-col>
      </v-row>
    </div>

    <div class="menu-item" @click="openTrilhaDeCuidados">
      <v-row>
        <v-col cols="6">
          <img
            src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/51990468-49c0-4d27-a166-de69bf5fbb54.svg"
            alt="">
        </v-col>

        <v-col class="item-text" cols="6">
          <v-chip style="background: #81D300; color: white; font-size: 10px;" density="compact">{{
            globalStateStore.calcularPorcentagemVoce() }}% completo</v-chip>

          <p class="item-title">Trilha de Cuidados</p>
        </v-col>
      </v-row>
    </div>


    <v-btn @click="showModalMudanca = true" style="width: 80%" color="#660099">Acionar Mudança</v-btn>
  </div>

  <ModalMudanca @interromper="interromperClicked" @grande-dia-chegou="grandeDiaClicked"
    @close-modal="showModalMudanca = false" v-if="showModalMudanca" />
</template>

<style scoped>
#menu-principal {
  width: 100%;
  height: 100%;
}

.top-area {
  margin-top: 10%;
}

.menu-item {
  background-color: #fff;
  width: 85%;
  height: 23%;
  border-radius: 8px;
  margin: 10% 7.5% 11%;
  cursor: pointer;
}

.menu-item img {
  width: 85%;
  margin: 10px 20px;
}

.item-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  text-align: flex-start;
}

.item-title {
  margin-top: 7px;
  width: 70%;
  text-align: left;
  font-size: 14px;
}

.speech {
  font-size: 10px;
  color: #fff;
  background: #BD4AFF;
  padding: 10px;
  border-radius: 10px;
  width: 35%;
}

.speech::after {
  display: block;
  width: 0;
  content: "";
  border: 15px solid transparent;
}

.speech.up::after {
  border-bottom-color: #BD4AFF;
  border-top: 0;
}

.speech {
  position: absolute;
  right: 4.5%;
  top: 21.5%;
}

.speech::after {
  position: absolute;
}

.speech.up::after {
  top: -10px;
  left: calc(50% - 30%);
}

.hidden {
  display: none;
}
</style>
